const Cash = [
    { id: "0", value: "營業活動現金" },
    { id: "1", value: "投資活動現金" },
    { id: "2", value: "籌資活動現金" },
    { id: "3", value: "資本支出" },
    { id: "4", value: "自由現金流" },
    { id: "5", value: "淨現金流" },
];

export default Cash  